import { Preview } from '@/screens/preview';

export default function PreviewScreen() {
  return <Preview />;
}
